import { render, staticRenderFns } from "./commodity-integral.vue?vue&type=template&id=9ec8c690&scoped=true&"
import script from "./commodity-integral.vue?vue&type=script&lang=js&"
export * from "./commodity-integral.vue?vue&type=script&lang=js&"
import style0 from "./commodity-integral.vue?vue&type=style&index=0&id=9ec8c690&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec8c690",
  null
  
)

export default component.exports